import React, { useState } from "react";
import axios from "axios";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Alert
} from "reactstrap";
import { useNavigate } from "react-router-dom";

const Register = () => {

  const navigate = useNavigate();

  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: ""
  });

  const [msg, setMsg] = useState("");
  const [error, setError] = useState("");

  // const API = "http://localhost/qads_interview/auth/";
  const API = "https://interview.qads.co.in/qads_interview/auth/";

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value
    });
  };

  const handleRegister = async (e) => {

    e.preventDefault();

    setMsg("");
    setError("");

    try {

      const res = await axios.post(
        API + "register_request.php",
        form
      );

      if (res.data.status) {

        setMsg("OTP sent to your email");

        setTimeout(() => {
          navigate("/verify-otp", {
            state: { email: form.email }
          });
        }, 1500);

      } else {

        setError(res.data.message);

      }

    } catch (err) {

      setError(
        err.response?.data?.message ||
        "Server error"
      );

    }

  };

  return (

    <div className="auth-wrapper">
      <Row className="justify-content-center w-100">
        <Col md="5">
          <Card className="auth-card">
            <CardBody>
              <h3 className="auth-title">Register</h3>

              {msg && <Alert color="success">{msg}</Alert>}
              {error && <Alert color="danger">{error}</Alert>}

              <Form onSubmit={handleRegister}>
                <FormGroup>
                  <Label>Name</Label>
                  <Input type="text" name="name" value={form.name} onChange={handleChange} required />
                </FormGroup>

                <FormGroup>
                  <Label>Email</Label>
                  <Input type="email" name="email" value={form.email} onChange={handleChange} required />
                </FormGroup>

                <FormGroup>
                  <Label>Phone</Label>
                  <Input type="text" maxLength="10" name="phone" value={form.phone} onChange={handleChange} required />
                </FormGroup>

                <Button type="submit" className="w-100 auth-btn">
                  Send OTP
                </Button>
              </Form>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>



  );

};

export default Register;